(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // The .js product endpoint only exists without a locale prefix
  // (/en/products/x.js and /fr/products/x.js return 404). Strip a trailing
  // /<locale>/ so fetches work on every language; links still use `root`.
  var fetchRoot = root.replace(/\/[a-z]{2}(-[a-z0-9]{2,})?\/$/i, '/');
  var cache = {};

  function money(cents) {
    return 'CHF ' + (cents / 100).toFixed(2);
  }

  function priceLabel(product) {
    var prices = product.variants.map(function (v) { return v.price; });
    var min = Math.min.apply(null, prices);
    var max = Math.max.apply(null, prices);
    return min === max ? money(min) : 'ab ' + money(min);
  }

  var SIZE_SHORT = { small: 'S', medium: 'M', large: 'L', 'x-large': 'XL', 'xx-large': 'XXL' };

  function sizeLabel(product) {
    var opt = (product.options || []).filter(function (o) {
      return /^gr[oö]/i.test(o.name);
    })[0] || (product.options || [])[0];
    if (!opt || !opt.values || !opt.values.length) return null;
    return opt.values.map(function (v) {
      return SIZE_SHORT[String(v).toLowerCase()] || v;
    }).join(', ');
  }

  function escapeAttr(s) {
    return String(s).replace(/"/g, '&quot;');
  }

  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(fetchRoot + 'products/' + handle + '.js').then(function (r) {
        if (!r.ok) throw new Error('product fetch failed: ' + handle);
        return r.json();
      });
    }
    return cache[handle];
  }

  function renderCard(el, product) {
    var url = root + 'products/' + product.handle;
    var img = '';
    if (product.featured_image) {
      var sep = product.featured_image.indexOf('?') > -1 ? '&' : '?';
      var alt = String(product.title).replace(/"/g, '&quot;');
      img = '<img class="obus-product-card__image" src="' + product.featured_image + sep + 'width=240" alt="' + alt + '" loading="lazy" width="120" height="120">';
    }
    var cta = product.available
      ? '<span class="obus-product-card__cta">Zum Produkt</span>'
      : '<span class="obus-product-card__cta obus-product-card__cta--unavailable">Zurzeit nicht verfügbar</span>';
    el.innerHTML =
      '<a class="obus-product-card" href="' + url + '">' + img +
      '<span class="obus-product-card__info">' +
      '<span class="obus-product-card__title">' + product.title + '</span>' +
      '<span class="obus-product-card__price">' + priceLabel(product) + '</span>' +
      cta + '</span></a>';
  }

  // Turn plain-text shortcodes (which survive the Shopify rich-text editor)
  // into the data-attribute mounts that get hydrated below.
  function expandShortcodes() {
    var containers = document.querySelectorAll('.article-template__content, .rte');
    containers.forEach(function (c) {
      if (c.innerHTML.indexOf('[[') === -1) return;
      c.innerHTML = c.innerHTML
        .replace(/<p[^>]*>\s*\[\[\s*product\s*:\s*([a-z0-9_-]+)\s*\]\]\s*<\/p>/gi, '<div data-product-card="$1"></div>')
        .replace(/\[\[\s*product\s*:\s*([a-z0-9_-]+)\s*\]\]/gi, '<div data-product-card="$1"></div>')
        .replace(/\[\[\s*price\s*:\s*([a-z0-9_-]+)\s*\]\]/gi, '<span data-product-price="$1">…</span>')
        .replace(/\[\[\s*sizes\s*:\s*([a-z0-9_-]+)\s*\]\]/gi, '<span data-product-sizes="$1">…</span>')
        .replace(/\[\[\s*title\s*:\s*([a-z0-9_-]+)\s*\]\]/gi, '<span data-product-title="$1"></span>');
    });
  }

  function init() {
    expandShortcodes();
    document.querySelectorAll('[data-product-card]').forEach(function (el) {
      getProduct(el.getAttribute('data-product-card'))
        .then(function (p) { renderCard(el, p); })
        .catch(function () { /* Fallback-Inhalt im Platzhalter bleibt stehen */ });
    });
    document.querySelectorAll('[data-product-price]').forEach(function (el) {
      getProduct(el.getAttribute('data-product-price'))
        .then(function (p) { el.textContent = priceLabel(p); })
        .catch(function () {});
    });
    document.querySelectorAll('[data-product-title]').forEach(function (el) {
      var handle = el.getAttribute('data-product-title');
      getProduct(handle)
        .then(function (p) {
          el.innerHTML = '<a href="' + root + 'products/' + p.handle + '">' + p.title + '</a>';
        })
        .catch(function () {});
    });
    document.querySelectorAll('[data-product-sizes]').forEach(function (el) {
      getProduct(el.getAttribute('data-product-sizes'))
        .then(function (p) {
          var label = sizeLabel(p);
          if (label) el.textContent = label;
        })
        .catch(function () {});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
